module.exports = __webpack_public_path__ + "static/img/guide.2d48489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide.png
// module id = UGiG
// module chunks = 55